/* eslint-disable i18next/no-literal-string */

import { Box, Typography } from "@outschool/backpack";
import React from "react";

import {
  INDOOR_BACKGROUNDS,
  OUTDOOR_BACKGROUNDS,
} from "./avatar-builder-constants";
import { capitalize } from "./avatar-builder-utils";
import { ChipButton } from "./AvatarBuilderFormControls";

export interface AvatarBuilderBackgroundTabProps {
  background: string;
  setBackground: React.Dispatch<React.SetStateAction<string>>;
}

export function AvatarBuilderBackgroundTab({
  background,
  setBackground,
}: AvatarBuilderBackgroundTabProps) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <Typography
          variant="subtitle2"
          sx={{ fontSize: "1.5rem", fontWeight: 600 }}
        >
          Outdoor backgrounds
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 8,
          }}
        >
          {OUTDOOR_BACKGROUNDS.map(bg => (
            <ChipButton
              key={bg}
              label={capitalize(bg)}
              selected={background === bg}
              onClick={() => setBackground(bg)}
            />
          ))}
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <Typography
          variant="subtitle2"
          sx={{ fontSize: "1.5rem", fontWeight: 600 }}
        >
          Indoor backgrounds
        </Typography>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: 8,
          }}
        >
          {INDOOR_BACKGROUNDS.map(bg => (
            <ChipButton
              key={bg}
              label={capitalize(bg)}
              selected={background === bg}
              onClick={() => setBackground(bg)}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
}
